<template>
  <div id="page" :class="computedFillHeight ? 'page-fill-height' : ''">
    <v-layout row class="pageLayout">
      <div>
        <div v-if="titleBar">
          <slot name="title">
            <div class="pl-4 headline pageTitle">{{ displayTitle }}</div>
          </slot>
        </div>
        <div v-if="this.breadcrumbBar" class="hidden-md-and-down">
          <slot name="breadcrumb">
            <v-breadcrumbs :items="breadcrumbRef"> </v-breadcrumbs>
          </slot>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="pageAction">
        <slot name="pageAction"></slot>
      </div>
    </v-layout>
    <div v-if="topMargin" class="pb-6"></div>
    <template v-if="init === 1">
      <slot></slot>
    </template>
    <template v-else-if="init === 0">
      <slot name="loading">
        <v-layout column justify-center align-center class="initPnl">
          <div>
            <v-flex>
              <v-progress-circular indeterminate v-bind:size="50" color="primary"></v-progress-circular>
            </v-flex>
            <v-flex class="pt-3">
              {{ loadText }}
            </v-flex>
          </div>
        </v-layout>
      </slot>
    </template>
    <template v-else>
      <slot name="error">
        <v-layout column justify-center align-center class="initPnl">
          <v-expansion-panels class="pageError">
            <v-expansion-panel-header class="pageErrorTitle">
              <div>
                <v-icon color="red">mdi-alert</v-icon>
                {{ errorText }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text class="grey lighten-3">
                  <ul class="pageErrorMsg">
                    <li v-for="(msg, index) in err" :key="index">{{ msg }}</li>
                  </ul>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panels>
          <div class="pt-3">
            <v-btn text @click="doReload">
              Reload
              <v-icon right>mdi-refresh</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </slot>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { APP_LOAD_THEME } from '@/store/types'

export default {
  data() {
    return {
      displayTitle: '',
      menuRef: undefined,
      breadcrumbRef: [],
      init: 0,
      err: []
    }
  },
  computed: {
    ...mapGetters(['getInternalMenu', 'derieveBreadcrumb']),
    computedFillHeight() {
      // If loading, we want it to fill height no matter wad
      if (this.init !== 1) {
        return true
      } else {
        return this.fillHeight
      }
    }
  },
  watch: {
    titleBar: function (value) {
      this.handleTitle()
    },
    title: function (value) {
      this.handleTitle()
    },
    breadcrumbBar: function (value) {
      this.handleBreadcrumb()
    },
    breadcrumb: function (value) {
      this.handleBreadcrumb()
    },
    manualInit: function (value) {
      this.init = value
    },
    manualErr: function (value) {
      this.err = value
    },
    '$route.fullPath': function (value) {
      // If there are nested route, we need update breadcrumb n title (if applicable)
      // Load Title
      this.handleTitle()

      // Load Breadcrumb
      this.handleBreadcrumb()
    }
  },
  methods: {
    handleTitle() {
      // If title is not passed in, we will try to derive it from menu
      if (this.titleBar) {
        if (this.title) {
          this.displayTitle = this.title
        } else {
          // Dynamically deriving title from menu
          if (this.$route && this.$route.name) {
            this.menuRef = this.getInternalMenu(this.$route.name)
            if (this.menuRef) {
              this.displayTitle = this.menuRef.text
            }
          }
        }
      }
    },
    handleBreadcrumb() {
      // If breadcrumb slots not use, we will derieve
      if (this.breadcrumbBar && !this.breadcrumb && !this.$slots['breadcrumb']) {
        // See if menuRef has been init by title, if not we will get it here again
        if (!this.menuRef) {
          this.menuRef = this.getInternalMenu(this.$route.name)
        }
        if (this.menuRef) {
          // Derieve breadcrumb here
          this.breadcrumbRef = this.formatBreadcrumb(this.derieveBreadcrumb(this.menuRef.key))
        }
      } else if (this.breadcrumbBar && this.breadcrumb && !this.$slots['breadcrumb']) {
        // Manual passed in breadcrumb value
        this.breadcrumbRef = this.formatBreadcrumb(this.breadcrumb)
      }
    },
    formatBreadcrumb(bc) {
      let result = []
      for (let x = 0; x < bc.length; x++) {
        const indexBC = bc[x]
        // Check if it is last index
        if (x === bc.length - 1) {
          result.push({
            text: indexBC.text,
            disabled: true
          })
        } else {
          result.push({
            text: indexBC.text,
            disabled: false,
            to: { name: indexBC.name },
            activeClass: 'breadcrumbs__item'
          })
        }
      }
      return result
    },
    doInit() {
      // Init variables
      this.init = 0
      this.err = []
      const loadResult = this.load()
      // Do note that the common use case is to pass in async function
      // the async function must throw the error in order to receive it here
      loadResult
        .then((result) => {
          this.init = 1
        })
        .catch((err) => {
          // Check if there are error messages
          if (err.response && err.response.data) {
            const { messages } = err.response.data
            if (messages && messages.length > 0) {
              messages.forEach((message) => {
                this.err.push(message.message)
              })
            }
          } else if (err.message) {
            // try catch err message
            this.err.push(err.message)
          }
          this.init = 2
        })
    },
    doReload() {
      if (this.manualInit === undefined) {
        this.doInit()
      } else {
        this.$emit('reload')
      }
    }
  },
  beforeMount() {
    // Check if full theme is activated
    if (!this.$store.state.app.loadTheme) {
      this.$store.commit(APP_LOAD_THEME, true)
    }

    // Load Title
    this.handleTitle()

    // Load Breadcrumb
    this.handleBreadcrumb()
  },
  mounted() {
    if (this.manualInit === undefined) {
      this.doInit()
    } else {
      this.init = this.manualInit
      this.err = this.manualErr
    }
  },
  props: {
    titleBar: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: undefined
    },
    breadcrumbBar: {
      type: Boolean,
      default: true
    },
    breadcrumb: {
      type: Array,
      default: undefined
    },
    topMargin: {
      type: Boolean,
      default: true
    },
    fillHeight: {
      // Do note: the framework is using flex. When height is fill to 100%
      // flex content will fill up the entire space
      type: Boolean,
      default: false
    },
    load: {
      // Need pass in a promise or async fucntion (which returns a promise)
      type: Function,
      default: function () {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve()
          }, 100)
        })
      }
    },
    loadText: {
      type: String,
      default: 'Loading...'
    },
    errorText: {
      type: String,
      default: 'Failed to load the required resource.'
    },
    manualInit: {
      // 2 ways to control loading in Page component
      // 1: Pass in a async load function (if success = 1, fail =2)
      // 2: Control it manually by passing in manualInit
      type: Number
    },
    manualErr: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
#page {
  width: 100%;
  &.page-fill-height {
    height: 100%;
    padding: 0;
    margin: 0;
  }
  .pageLayout {
    // Layout will auto fill screen if v-container has fill height.
    // We do not want titlebar to fill up the screen
    height: auto !important;
  }
  .initPnl {
    // Full height in this case will not take into consideration of title and breadcrumb height. It will exceed.
    // This is a workaround
    height: 70%;
  }
  .pageError {
    max-width: 700px;
    .pageErrorTitle {
      text-align: center;
    }
    .pageErrorMsg {
      padding-left: 15px;
    }
  }
  .pageTitle {
    display: inline-block;
  }
  .pageAction {
    display: inline-block;
    .actionBlock {
      display: inline-block;
    }
  }
}
</style>
